import { AuthLayout, AuthShowcase, LanguageSwitch, Logo } from '@hemmafixa/ui';
import type { ComponentProps } from 'react';
import { useI18n } from '@/i18n/context';

type AuthPageProps = Omit<ComponentProps<typeof AuthLayout>, 'brand' | 'actions'>;

/** Example companies drawn as avatars on the brand panel */
const SHOWCASE_COMPANIES = ['Bygg & Fix', 'VVS Experten', 'El-Kraft', 'Takläggarna'];

/** The signed-out page frame: the navy brand panel with its picture, logo, language switch and the form. */
export function AuthPage(props: AuthPageProps) {
  const { t, language, setLanguage } = useI18n();
  const sc = t.auth.showcase;
  return (
    <AuthLayout
      brand={<Logo />}
      brandOnDark={<Logo tone="light" />}
      panel={t.auth.panel}
      showcase={
        <AuthShowcase
          proposal={{ company: sc.company, label: sc.label, price: sc.price, status: sc.status }}
          message={{ from: sc.from, text: sc.message }}
          progress={{ label: sc.progress, value: 3, max: 3 }}
          companies={{ names: SHOWCASE_COMPANIES, caption: sc.caption }}
        />
      }
      actions={<LanguageSwitch value={language} onChange={setLanguage} label={t.layout.language} />}
      {...props}
    />
  );
}
